export const InvoicesTypes = {
  IQueryInvoicesService: Symbol("IQueryInvoicesService"),
  IDownloadPDFInvoicesService: Symbol("IDownloadPDFInvoicesService"),
};
